<template>
  <v-container pa-0 fluid>
    <v-stepper v-model="e1">
      <v-stepper-header style="display:none">
        <v-stepper-step step="1"></v-stepper-step>
        <v-stepper-step step="2"></v-stepper-step>
        <v-stepper-step step="3"></v-stepper-step>
        <v-stepper-step step="4"></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1" id="home">
          <v-layout class="text-xs-center justify-center align-center align-content-center">
            <v-flex xs12 ma-2>
              <h1>Web Engineer</h1>
              <h2 class="font-weight-regular">Solutions through code</h2>
              <v-btn to="/home/2" class="subheading action-btn">
                <v-icon class="animated infinite pulse tada slower">arrow_right_alt</v-icon>
                <h3 style="line-height: initial;padding-left:5px">Start Here</h3>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-3" id="home">
          <v-card style="max-width: 1200px">
            <v-layout wrap align-center justify-center>
              <v-flex lg6 xs12>
                <v-card-text>
                  <h2 class="font-weight-bold">
                    <u>Engineering web products since 2013</u>
                  </h2>
                  <code class="about-content">
                      <h3 class="typewriter"  v-html="typedText"></h3>
                    </code>
                  <v-btn outline block large class="subheading action-btn" to="/home/3" v-scroll-to="'#element'">
                    <h2 style="line-height: initial">Portfolio</h2>
                    <v-icon class="animated infinite pulse tada slower">arrow_right_alt</v-icon>
                  </v-btn>
                </v-card-text>
              </v-flex>
              <v-flex lg6 xs6>
                <img width="100%" loading="lazy" src="/static/dev.gif " alt="Developer Coding">
              </v-flex>
            </v-layout>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3" id="home">
          <v-layout wrap justify-center align-center style="padding-bottom:50px;max-width: 1366px; margin: 0 auto;">
            <v-flex lg4 md6 xs12>
              <v-card id="element" class="work-card" @mouseover="active += 1">
                <a href="https://kendama.co">
                  <h2 class="black--text">
                    Kendama Community↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front align-center" style="background-image: url(/static/work/ken2.jpg);">
                  </div>
                  <div class="back">
                    <p>Founder<br> March 2021 - Present</p>
                    <span class="work-tag">Striving to help beginners<br> play Kendama easy and fast</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card id="element" class="work-card" @mouseover="active += 1">
                <a href="https://scufgaming.com">
                  <h2 class="black--text">
                    Scuf Gaming↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front align-start" style="background-image: url(/static/work/sg.jpg);">
                    <v-btn outline color="white" class="tindicator" v-if="!active">HOVER <v-icon class="animated infinite pulse tada slower">touch_app</v-icon>
                    </v-btn>
                  </div>
                  <div class="back">
                    <p>Front-end Developer<br> July 2021 - Present</p>
                    <span class="work-tag">Magento 2</span>
                    <span class="work-tag">JavaScript</span>
                    <span class="work-tag">PHP</span>
                    <span class="work-tag">Prismic</span>
                    <span class="work-tag">jQuery</span>
                    <span class="work-tag">XML</span>
                    <span class="work-tag">Less</span>
                    <span class="work-tag">phtml</span>
                    <span class="work-tag">Asset Management</span>
                    <span class="work-tag">NPM</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card id="element" class="work-card" @mouseover="active += 1">
                <a href="https://gitcoin.co">
                  <h2 class="black--text">
                    Gitcoin↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front align-start" style="background-image: url(/static/work/git.jpg);">
                  </div>
                  <div class="back">
                    <p>Bug Bounties<br> Jan 2021 - Present</p>
                    <span class="work-tag">Solidity + Web3 Development</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card id="element" class="work-card" @mouseover="active += 1">
                <a href="https://polyglotlabs.com">
                  <h2 class="black--text">
                    Polyglot Labs↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front align-start" style="background-image: url(/static/work/poly.jpg);">
                  </div>
                  <div class="back">
                    <p>Front-end Developer<br> September 2018 - December 2020</p>
                    <span class="work-tag">HTML/CSS</span>
                    <span class="work-tag">JavaScript</span>
                    <span class="work-tag">PHP</span>
                    <span class="work-tag">Angular</span>
                    <span class="work-tag">WordPress</span>
                    <span class="work-tag">jQuery</span>
                    <span class="work-tag">SQL</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card class="work-card">
                <a href="https://blakejs.github.io/awesomely">
                  <h2 class="black--text">
                    Awesomely↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front align-center" style="background-image: url(/static/work/awesome.jpg); display:grid">
                  </div>
                  <div class="back">
                    <p>Web application for organizing <a href="https://github.com/sindresorhus/awesome">Awesome Lists</a> into a Resources Dashboard.</p>
                    <span class="work-tag">Vue.js</span>
                    <span class="work-tag">Vuetify</span>
                    <span class="work-tag">Vuex</span>
                    <span class="work-tag">Vue-router</span>
                    <span class="work-tag">Webpack</span>
                    <span class="work-tag">Node.js</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card class="work-card">
                <h2 class="black--text">
                  Super Smash Bros Counters
                </h2>
                <div class="flip">
                  <div class="front" style="background-image: url(/static/work/ssbu.jpg)">
                  </div>
                  <div class="back">
                    <p>Web application for finding counter champions in Super Smash Bros Ultimate.</p>
                    <span class="work-tag">Handlebars</span>
                    <span class="work-tag">SASS</span>
                    <span class="work-tag">ES6</span>
                    <span class="work-tag">Node.js</span>
                    <span class="work-tag">MongoDB</span>
                    <span class="work-tag">jQuery</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card class="work-card">
                <a href="https://litterboxd.com">
                  <h2 class="black--text">
                    Litterboxd↗
                  </h2>
                </a>
                <div class="flip">
                  <div class="front" style="background-image: url(/static/work/litterboxd.jpg)">
                  </div>
                  <div class="back">
                    <p>Web application for finding and watching movies with your cat.</p>
                    <span class="work-tag">React.js</span>
                    <span class="work-tag">SASS</span>
                    <span class="work-tag">ES6</span>
                    <span class="work-tag">Axios</span>
                    <span class="work-tag">Netlify</span>
                    <span class="work-tag">RESTful API (TMDB)</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card class="work-card">
                <h2 class="black--text">
                  Southern Architectural Stone
                </h2>
                <div class="flip">
                  <div class="front" style="background-image: url(/static/work/sas.jpg)">
                  </div>
                  <div class="back">
                    <p>Freelance development of company website for small business.</p>
                    <span class="work-tag">PHP</span>
                    <span class="work-tag">jQuery</span>
                    <span class="work-tag">Bootstrap</span>
                    <span class="work-tag">SQL</span>
                    <span class="work-tag">Custom Wordpress Development</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12>
              <v-card class="work-card">
                <h2 class="black--text">
                  Mobile Legends Counters
                </h2>
                <div class="flip">
                  <div class="front" style="background-image: url(/static/work/mlc.jpg)">
                  </div>
                  <div class="back">
                    <p>Web application for finding counter champions in Mobile Legends.</p>
                    <span class="work-tag">Handlebars</span>
                    <span class="work-tag">SASS</span>
                    <span class="work-tag">ES6</span>
                    <span class="work-tag">Node.js</span>
                    <span class="work-tag">MongoDB</span>
                    <span class="work-tag">jQuery</span>
                  </div>
                </div>
              </v-card>
            </v-flex>
            <v-flex lg4 md6 xs12 align-content-center style="display:block;text-align:center;font-size:16px;margin-top:7px;">
              <v-btn class="action-btn" to="/garden">
                <h2 style="line-height: initial; padding-right: 15px;">Garden</h2>
                <v-icon>view_in_ar</v-icon>
              </v-btn>
            </v-flex>
            <v-flex lg4 md6 xs12 align-content-center style="display:block;text-align:center;font-size:16px;margin-top:7px;">
              <v-alert :value="show" icon="assignment_turned_in" color="success" dark border="top" transition="scroll-y-transition" :dismissible="true">
                Copied to Clipboard
              </v-alert>
              <v-btn v-clipboard:copy="message" v-clipboard:success="onCopy" v-clipboard:error="onError" class="action-btn">
                <h2 style="line-height: initial; padding-right: 15px;">&#105;&#110;&#102;&#111;&#064;&#098;&#108;&#097;&#107;&#101;&#106;&#115;&#046;&#099;&#111;&#109;</h2>
                <v-icon>forum</v-icon>
              </v-btn>
            </v-flex>
            <v-flex lg4 md6 xs12 align-content-center style="display:block;text-align:center;font-size:16px;margin-top:7px;">
              <v-btn class="action-btn" to="/resume">
                <h2 style="line-height: initial; padding-right: 15px;">Résumé</h2>
                <v-icon>article</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      e1: 0,
      message: 'info@blakejs.com',
      show: false,
      switch1: true,
      typedText: '',
      textToType: [
        '> Name: Blake James Sutton (A.K.A. BlakeJS)',
        '> About: I create software, websites, web applications, and solutions. I love building unique and memorable digital experiences with the latest web technologies and creative design. Translating ideas into semantic, accessible, and scalable code is my passion.',
        '> Technical skill set: React + Vue, Redux + Vuex, Javascript + Typescript, SASS + LESS, PHP, Dev Tools, AWS, Git, RESTful APIs and <a href="https://github.com/blakejs">more</a>!',
        '> Interest: Front-end Development, Product Design, Performance Optimization, Progressive Enhancement, Responsivity, Leadership, Agile Development, and Linux.'
      ],
      typingSpeed: 9,
      blinkingCursorSpeed: 500,
      currentLineIndex: 0,
      typeInterval: null,
      blinkInterval: null
    };
  },
  updated() {
    this.e1 = this.$route.params.id;
  },
  mounted() {
    this.setupObserver();
  },
  methods: {
    setupObserver() {
      const options = {
        root: null,
        threshold: 0.1
      };

      this.observer = new IntersectionObserver(this.handleIntersect, options);
      const target = this.$el.querySelector('.about-content');
      if (target) {
        this.observer.observe(target);
      }
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.typeText();
          this.observer.disconnect(); 
        }
      });
    },
    typeText() {
      this.clearIntervals();
      if (this.currentLineIndex < this.textToType.length) {
        const currentLine = this.textToType[this.currentLineIndex];
        let i = 0;
        this.typeInterval = setInterval(() => {
          if (i < currentLine.length) {
            this.typedText += currentLine[i];
            i++;
          } else {
            this.clearIntervals();
            this.typedText += '<br>';
            this.currentLineIndex++;
            this.typeText();
          }
        }, this.typingSpeed);
      } else {
        this.blinkCursor();
      }
    },
    blinkCursor() {
      this.clearIntervals();
      this.blinkInterval = setInterval(() => {
        if (this.typedText.endsWith('_')) {
          this.typedText = this.typedText.slice(0, -1);
        } else {
          this.typedText += '_';
        }
      }, this.blinkingCursorSpeed);
    },
    clearIntervals() {
      if (this.typeInterval) {
        clearInterval(this.typeInterval);
        this.typeInterval = null;
      }
      if (this.blinkInterval) {
        clearInterval(this.blinkInterval);
        this.blinkInterval = null;
      }
    },
    clearData() {
      this.clearIntervals();
      this.typedText = '';
      this.currentLineIndex = 0;
    },
    mouseOver: function () {
      this.active = !this.active;
    },
    onCopy: function (e) {
      this.show = !this.show;
    },
    onError: function (e) {
      alert('Failed to copy texts')
    }
  },
  computed: {
    typedHtml() {
      return this.typedText.replace(/\n/g, '<br>');
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearData();
    next();
  },
  beforeDestroy() {
    this.clearData();
    if (this.observer) {
      this.observer.disconnect();
    } 
  },
  watch: {
    "$route.params.id"() {
      this.e1 = this.$route.params.id;
    }
  },
  name: "Home"
};
</script>
<style scoped>
.typewriter {
  display: inline-block;
  font-family: 'Courier New', monospace;
  font-size: 1.2rem;
  width: auto;
  min-width: 100%;
  white-space: normal;
  overflow: visible;
  animation: typing 4s steps(40, end), blink-caret 0.75s step-end infinite;
}

@keyframes typing {
  from {
    width: 0
  }

  to {
    width: 100%
  }
}

@keyframes blink-caret {
  from,
  to {
    border-color: transparent
  }

  50% {
    border-color: green
  }
}

#home h1 {
  font-size: 4rem;
  line-height: normal;
}

div {
  font-family: "Inconsolata", monospace;
}

.flip a {
  color: #2d2d2d
}

.container {
  height: 100%;
  background-image: linear-gradient(-20deg, #dcb0ed 0%, #99c99c 100%);
}

.v-stepper {
  display: grid;
  place-items: center;
  height: inherit;
  background: transparent !important;
  background-repeat: repeat;
}

#home {
  height: -webkit-fill-available;
  height: -moz-available;
  height: fill-available;
  min-height: fit-content;
}

.about-content {
  color: black;
  background-color: #eff6fa;
  padding: 0 20px;
  font-size: 1em;
  width: 577px;
  min-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 28rem;
  border-radius: 0;
}

.work-card {
  display: grid;
  justify-items: center;
  align-items: center;
  text-align: center;
  margin: 10px;
}

.work-card:hover {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.417);
}

.work-tag {
  display: inline-block;
  padding: 0 0.2em;
  margin-right: 0.5em;
  margin-bottom: 0.4em;
  font-size: 140%;
  font-weight: bold;
  background: #2d2d2d;
  color: #fff;
}

.work-card-title {
  justify-content: center;
  display: grid;
  grid-auto-flow: column;
}

.v-stepper__content {
  padding: 0;
}

.flip {
  position: relative;
}

.flip>.front,
.flip>.back {
  display: block;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-duration: 0.5s;
  transition-property: transform, opacity;
}

.flip>.front {
  transform: rotateY(0deg);
}

.flip>.back {
  position: absolute;
  opacity: 0;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  transform: rotateY(-180deg);
}

.flip:hover>.front {
  transform: rotateY(180deg);
}

.flip:hover>.back {
  opacity: 1;
  transform: rotateY(0deg);
}

.flip.flip-vertical>.back {
  transform: rotateX(-180deg);
}

.flip.flip-vertical:hover>.front {
  transform: rotateX(180deg);
}

.flip.flip-vertical:hover>.back {
  transform: rotateX(0deg);
}

.flip {
  position: relative;
  display: inline-block;
  margin-right: 2px;
  margin-bottom: 1em;
  width: 95%;
}

.flip>.front,
.flip>.back {
  display: block;
  color: #000;
  background-size: auto 95% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  height: 200px;
  width: 100%;
  padding: 1em 2em;
  background: #fff;
  border-radius: 10px;
}

.flip>.front p,
.flip>.back p {
  font-size: 1.2rem;
  line-height: 130%;
  color: #000;
}

.v-alert.v-alert {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
  bottom: 30px;
}

.tindicator {
  margin-top: 60px;
}

@media (max-width: 1263px) {
  #home {
    padding: 0 !important;
  }

  .home-container {
    position: relative;
    height: 100%;
  }

  .home-content {
    height: 90vh;
  }

  .home-hero-content {
    position: fixed;
  }

  .about-content {
    width: auto;
    height: 36em;
  }

  .work-card {
    height: 350px;
  }

  .flip>.front,
  .flip>.back {
    padding: 0;
  }
}
@media (max-width: 500px) {
  .about-content {
    width: auto;
    height: 50em;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue